import { render, staticRenderFns } from "./composantContributionTDD.vue?vue&type=template&id=4efe184a&scoped=true"
import script from "./composantContributionTDD.vue?vue&type=script&lang=js"
export * from "./composantContributionTDD.vue?vue&type=script&lang=js"
import style0 from "./composantContributionTDD.vue?vue&type=style&index=0&id=4efe184a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe184a",
  null
  
)

export default component.exports